import { BASE_URL_API } from 'constants/base-url-default'
import { getCookie } from 'utils/functions-cookie'

export interface Root {
  street_name: string
  street_number: string
  neighborhood: string
  city: string
  state: string
  complement: string
  detail?: string
}

export const updateCompanyAddress = async (address: Root) => {
  const authToken = getCookie('auth_token')

  if (!authToken) {
    throw new Error('Você não está autenticado.')
  }

  const response = await fetch(`${BASE_URL_API}/companies/address`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json',
    },

    body: JSON.stringify(address),
  })

  if (!response.ok) {
    throw new Error('Erro ao atualizar endereço.')
  }
}
